import Header from "@editorjs/header";
import Embed from "@editorjs/embed";
import Image from "@editorjs/image";
import Link from "@editorjs/link";
import List from "@editorjs/list";
import Quote from "@editorjs/quote";
import Table from "@editorjs/table";
import Warning from "@editorjs/warning";
import Marker from "@editorjs/marker";
import Code from "@editorjs/code";
import InlineCode from "@editorjs/inline-code";
import Raw from "@editorjs/raw";
import Checklist from "@editorjs/checklist";
import Delimiter from "@editorjs/delimiter";

import { createReactEditorJS } from "react-editor-js";

const Editor = ({ data }) => {
  const ReactEditor = createReactEditorJS();

  return (
    <ReactEditor
      tools={{
        embed: Embed,
        header: Header,
        image: Image,
        link: Link,
        list: List,
        quote: Quote,
        table: Table,
        warning: Warning,
        marker: Marker,
        code: Code,
        inlineCode: InlineCode,
        raw: Raw,
        checklist: Checklist,
        delimiter: Delimiter,
      }}
      defaultValue={data}
      readOnly={true}
    />
  );
};

export default Editor;
